import { Box } from "@mui/material";
import styled from "styled-components";

export const InviteUsersStyled = styled(Box)`
  .btn-wrapper {
    display: flex;
    justify-content: space-between;
    column-gap: 16px;
    align-items: center;
    .icon-btn {
      display: none;
    }

    .text-btn {
      display: flex;
    }
  }

  @media (max-width: 576px) {
    .btn-wrapper {
      .icon-btn {
        display: flex;
      }

      .text-btn {
        display: none;
      }
    }
  }
`;
